
import { Component, Prop, Vue } from "vue-property-decorator";
import rules from "@/store/rules";
import { ArticleState } from "@/dtos/articleState";
import { CartItem } from "@/dtos/cartItem";
import TooManyCalculatingDialog from "@/views/Dialogs/TooManyCalculatingDialog.vue";
import httpClient from "../../store/httpClient";
import { CustomerArticleDto } from "@/dtos/customerArticleDto";

@Component({ components: { TooManyCalculatingDialog } })
export default class CartPositionItem extends Vue {
	@Prop()
	private position!: CartItem;
	@Prop()
	private isPartOfAssembly!: boolean;
	@Prop()
	private isLoadingSubarticles!: boolean;
	private allowedCartAmountRule = rules.allowedCartAmountRule;
	private tooManyCalculatingDialog: boolean = false;

	private get article() {
		return this.$store.getters.articleById(this.position.articleId);
	}

	private get subarticles() {
		return this.$store.getters.subarticlesByParentId(this.position.articleId);
	}

	private get articleQuantity() {
		if (this.isPartOfAssembly) {
			return this.article.quantityInAssembly * this.position.quantity;
		} else {
			return this.position.quantity;
		}
	}
	private set articleQuantity(quantity: any) {
		const parsed: number = parseInt(quantity);
		if (quantity !== undefined && !isNaN(parsed) && parsed > 0) {
			this.$store.commit("setAmountOfCartItem", {
				articleId: this.position.articleId,
				quantity: parsed,
			});
		}
	}

	private saveArticleQuantity() {
		this.$store.dispatch("setAmountOfCartItem", {
			articleId: this.position.articleId,
			quantity: this.articleQuantity,
		});
	}

	private get certificate(): string {
		return this.article.certificateTypes > 0 ? "3.1" : "";
	}

	private get selectedSavedCartId(): number {
		return this.$store.state.currentSavedCartId;
	}

	private get articleState(): ArticleState {
		let allArticles = [];
		if (!this.article.isAssembly) {
			allArticles.push(this.article);
		} else {
			allArticles = this.subarticles;
		}
		if (
			allArticles.some(
				(a: CustomerArticleDto) =>
					a.calculating ||
					a.migrated ||
					a.locked ||
					(a.state !== ArticleState.OK && a.state !== ArticleState.Warning)
			)
		) {
			return ArticleState.Error;
		}
		if (allArticles.some((a: CustomerArticleDto) => a.state === ArticleState.Warning)) {
			return ArticleState.Warning;
		}
		return ArticleState.OK;
	}

	private removeFromCart() {
		this.$store.dispatch("removeArticleFromCart", this.position.articleId);
	}

	private addToSavedCart() {
		this.$store.dispatch("addArticleToSavedCart", {
			amount: this.articleQuantity,
			articleId: this.position.articleId,
			customerArticleName: this.article.customerArticleName,
		});
	}

	private get thumbnailUrl() {
		return this.$store.getters.getThumbnailUrl(this.position.articleId, undefined);
	}

	private async revalidate() {
		try {
			this.$store.commit("setArticleStateToCalculating", this.position.articleId);
			const response = await httpClient().post(
				`article/revalidate?articleId=${this.position.articleId}`
			);
			if (response.data === false) {
				// User is calculating too many articles at once
				this.tooManyCalculatingDialog = true;
			}
		} catch (err) {
			console.log(`Fehler beim erneuten Validieren des Artikels. Error: ${err}`);
		}
	}

	private articleStateIcon() {
		switch (this.articleState) {
			case ArticleState.OK: {
				return "mdi-check-circle";
			}
			case ArticleState.Warning: {
				return "mdi-alert-circle";
			}
			default: {
				return "mdi-close-circle";
			}
		}
	}

	private articleStateColor() {
		switch (this.articleState) {
			case ArticleState.OK: {
				return "#97b498";
			}
			case ArticleState.Warning: {
				return "#cbc693";
			}
			default: {
				return "#cb9ca1";
			}
		}
	}
}
